import { GameManager } from "../../GameManager";
import { GameVars } from "../../GameVars";
import { RouletteContainer } from "./roulette/RouletteContainer";
import { RouletteModel } from "./roulette/RouletteModel";
import { RouletteScene } from "./RouletteScene";

export class RouletteManager {

    public static currentInstance: RouletteManager;

    constructor() {
        
        RouletteManager.currentInstance = this;
    }

    public spin(): void {

        (async () => {

            GameVars.spinResponse = await GameManager.api.postSpin();
            // console.log("api.postSpin")
            // console.log("Prize won id: ", GameVars.spinResponse.prize.id);

            const retryCountResponse = await GameManager.api.fetchRetryCount();
            // console.log("api.fetchRetryCount")
            // console.log("Spins left: ", retryCountResponse.amount);
            GameVars.spinsCounter = retryCountResponse.amount;

            GameVars.prizeResults = await GameManager.api.fetchPrizes();

            RouletteScene.currentInstance.showStopButton();

        })();

        RouletteScene.currentInstance.spin();
    }

    public stop(): void {
        
        GameVars.i = this.getPrizeIndex(GameVars.spinResponse.prize.id); 

        let targetAngle: number;

        if (GameVars.i < 8)  {
            targetAngle = 36 * (8 - GameVars.i);
        } else {
            targetAngle = 36 * (18 - GameVars.i);
        }

        const rouletteModel = RouletteScene.currentInstance.roulette.rouletteModel;

        const emulationsRouletteModel = new RouletteModel();

        let slowDownAngularSpeed: number;

        let i = 0;

        for (slowDownAngularSpeed = 0.01; slowDownAngularSpeed < 0.3; slowDownAngularSpeed += 0.0001) {

            i ++;

            emulationsRouletteModel.a = rouletteModel.a;
            emulationsRouletteModel.f = rouletteModel.f;
            emulationsRouletteModel.deltaAngle = rouletteModel.deltaAngle;
            emulationsRouletteModel.spin();
            emulationsRouletteModel.stop(slowDownAngularSpeed);

            while (emulationsRouletteModel.spinning)  {
                emulationsRouletteModel.update();
            }

            const finalAngle = emulationsRouletteModel.getAngle();

            if (finalAngle > targetAngle - 3.5 && finalAngle < targetAngle - .5) {
                break;
            }
        }

        console.log("slowDownAngularSpeed:", slowDownAngularSpeed, " i:",i)

        RouletteScene.currentInstance.stop(slowDownAngularSpeed);
    }

    public onRouletteStopped(): void {

        RouletteScene.currentInstance.onRouletteStopped();
    }

    private getPrizeIndex(id: number): number {

        let i: number;

        for (i = 0; i < GameVars.prizeResults.prizes.length; i ++) {
            if (GameVars.prizeResults.prizes[i].id === id) {
                break;
            }
        }

        return i + 1;
    }
}
